'use client';

import CommonErrorPage from '~/components/common/appRouter/CommonErrorPage';

export default function Error({
  error
}: {
  error: Error & { digest?: string };
}) {
  return <CommonErrorPage page="new" error={error} inCarvanaLayout />;
}
